import { AccountType, AccountTypeEnum } from '@/context/types/Account';

export const getTableHeaders = (accountType: AccountType, hasGLCodes: boolean) => {
  return hasGLCodes
    ? extractByAccountType(accountType, tableHeadersWithGLCode)
    : extractByAccountType(accountType, tableHeaders);
};

const extractByAccountType = (
  accountType: AccountType,
  headers: {
    label: string;
    canSort: boolean;
    accountType: AccountType[];
  }[]
) => headers.filter((header) => header.accountType.some((type) => type === accountType));

const BOTH_ACCOUNT_TYPES = [AccountTypeEnum.BUSINESS, AccountTypeEnum.PERSONAL];

export const tableHeaders = [
  {
    label: 'Date',
    canSort: true,
    accountType: BOTH_ACCOUNT_TYPES
  },
  {
    label: 'To/From',
    canSort: false,
    accountType: BOTH_ACCOUNT_TYPES
  },
  {
    label: 'Status',
    canSort: false,
    accountType: BOTH_ACCOUNT_TYPES
  },
  {
    label: 'Type',
    canSort: false,
    accountType: BOTH_ACCOUNT_TYPES
  },
  {
    label: 'Amount',
    canSort: false,
    accountType: BOTH_ACCOUNT_TYPES
  },
  {
    label: 'Details',
    canSort: false,
    accountType: BOTH_ACCOUNT_TYPES
  },
  {
    label: '',
    canSort: false,
    accountType: BOTH_ACCOUNT_TYPES
  }
];

export const tableHeadersWithGLCode = [
  {
    label: 'Date',
    canSort: true,
    accountType: BOTH_ACCOUNT_TYPES
  },
  {
    label: 'To/From',
    canSort: false,
    accountType: BOTH_ACCOUNT_TYPES
  },
  {
    label: 'Status',
    canSort: false,
    accountType: BOTH_ACCOUNT_TYPES
  },
  {
    label: 'GL code',
    canSort: false,
    accountType: [AccountTypeEnum.BUSINESS]
  },
  {
    label: 'Type',
    canSort: false,
    accountType: BOTH_ACCOUNT_TYPES
  },
  {
    label: 'Amount',
    canSort: false,
    accountType: BOTH_ACCOUNT_TYPES
  },
  {
    label: 'Details',
    canSort: false,
    accountType: BOTH_ACCOUNT_TYPES
  },
  {
    label: '',
    canSort: false,
    accountType: BOTH_ACCOUNT_TYPES
  }
];

export const allowedHeaderOnTabletView = ['Date', 'To/From', 'Type', 'Amount', 'Details', ''];
